<template>
    <div
        v-if="tagsList && tagsList.length"
        class="tags"
    >
        <nav class="d-flex justify-content-start">
            <span
                v-if="title"
                class="typo-caption-2 tags__title ml-1"
            >
                {{ title }}
            </span>
            <ul class="ma-0 pa-0 d-flex flex-wrap">
                <li
                    v-for="(tag, index) in tagsList"
                    :key="tag.id"
                    class="tags__links"
                >
                    <router-link
                        :to="routeTo(routeName, tag)"
                        class="typo-caption-2 tags__link"
                    >
                        {{ tag.title }}
                    </router-link>
                    <template v-if="index !== tagsLength - 1">
                        <span class="typo-caption-2 ml-1">
                            {{ $t('blog.separator') }}
                        </span>
                    </template>
                </li>
            </ul>
        </nav>
    </div>
</template>

<script>

    export default {
        name: 'Tags',
        
        props: {
            /**
             * tags list of post
             */
            tagsList: Array,

            /**
             * tags title
             */
            title: String,

            /**
             * route name 
             */
            routeName: String,
            
        },

        computed: {
            /**
             * Cats length
             *
             * @returns {string}
             */
            tagsLength() {
                return this.tagsList.length;
            },
        },
    };
</script>

<style lang="scss" src="./index.scss" />
